export default {
    'Select partner': 'Партнер',
    'Partner': 'Партнер',
    'Package': 'Package',
    'Select group': 'Група',
    'Add group': 'Додати групу',
    'Select program': 'Програма',
    'Select module': 'Модуль',
    'In full screen': 'На весь екран',
    'Lessons / Homework': 'Уроки / Домашня робота',
    'Students': 'Студенти',
    'Average score': 'Середня оцінка',
    'Absence': 'Пропуски',
    'Finished Lessons': 'Завершені уроки',
    'Ratings, comments': 'Коментарі оцінки',
    'Presence': 'Присутність',
    'Close': 'Закрити',
    'Next page >>': 'Наступна сторінка >>',
    '<< Previous page': '<< Попередня сторінка',
    'transfer to another class or withdraw from the class?': 'перевести в інший клас або вийти з класу?',
    'Transfer to another class': 'Перевести до іншого класу',
    'transfer to another class': 'Перевести до іншого класу',
    'Select a class': 'Оберіть клас',
    'Transfer': 'Перевести',
    'Exclude': 'Виключити',
    'student from the class': 'студент з класу',
    'Are you sure about the student deduction?': 'Ви впевнені щодо студентського відрахування?',
    'Set new schedule': 'Встановіть новий розклад',
    'Time start for all lessons': 'Час початку всіх уроків',
    'Time end for all lessons': 'Час закінчення всіх уроків',
    'Timetable': 'Графік',
    'Lesson type for ': 'Тип уроку для ',
    'Exclude dates': 'Виключити дати',
    'Education start': 'Початок навчання',
    'Teacher for ': 'Вчитель для ',
    'Add new program': 'Додати нову програму',
    'Remove program': 'Видалити програму',
    'Average score (Classwork)': 'Середній бал (Класна робота)',
    'Average score (Homework)': 'Середній бал (Домашня робота)',
    'Classwork': 'Класна робота',
    'Homework': 'Домашня робота',
    'Check the task': 'Перевірити завдання',
    'Class': 'Клас',
    'Cancel': 'Відмінити',
    'Reject': 'Відхилити',
    'The reason for the rejection of the file': 'Причина відхилення файлу',
    'Rejected': 'Відхилино',
    'New file': 'Новий файл',
    'Download file': 'Завантажити файл',
    'Rejected file': 'Повернутий файл',
};
